import React, { useCallback, useEffect, useMemo } from 'react';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { TLanguageIDs } from 'types';
import { trueOrderLanguageIDs } from 'appConstants';
import style from './LanguageBar.module.scss';

interface ILanguageBar {
	setTranslationTab: (value: TLanguageIDs | null) => void;
	selectedTranslationTab: TLanguageIDs | null;
	IDsSelectedLanguages: TLanguageIDs[];
}

const LanguageBar: React.FC<ILanguageBar> = ({ IDsSelectedLanguages, selectedTranslationTab, setTranslationTab }) => {
	const getTrueLanguagesOrder = useCallback(() => {
		const languages = [...IDsSelectedLanguages];
		const sortByObject: { [key: string]: number } = trueOrderLanguageIDs.reduce((obj, item, index) => {
			return {
				...obj,
				[item]: index,
			};
		}, {});
		languages.sort((a, b) => sortByObject[a] - sortByObject[b]);
		return languages;
	}, [IDsSelectedLanguages]);

	const sortedLanguages = useMemo<TLanguageIDs[]>(() => getTrueLanguagesOrder(), [getTrueLanguagesOrder]);

	const languageBarItemsList = useMemo(() => {
		return sortedLanguages.map((el) => (
			<LanguageBarItem
				key={el}
				languageId={el}
				isActive={selectedTranslationTab === el}
				onClick={() => setTranslationTab(el)}
			/>
		));
	}, [sortedLanguages, selectedTranslationTab, setTranslationTab]);

	useEffect(() => {
		const defaultValue = sortedLanguages.length ? sortedLanguages[0] : null;
		setTranslationTab(defaultValue);
	}, [sortedLanguages.length]);

	return (
		<>
			{IDsSelectedLanguages.length ? (
				<div className={style.container} data-test="LanguageBar">
					{languageBarItemsList}
				</div>
			) : null}
		</>
	);
};

export default React.memo(LanguageBar);
